import { render, staticRenderFns } from "./GlyphProtectedRowButtonGroup.vue?vue&type=template&id=0b9f4462&scoped=true"
import script from "./GlyphProtectedRowButtonGroup.vue?vue&type=script&lang=js"
export * from "./GlyphProtectedRowButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./GlyphProtectedRowButtonGroup.vue?vue&type=style&index=0&id=0b9f4462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f4462",
  null
  
)

export default component.exports